import React from 'react'
import Logo from './SidePanel/logo.js'

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import TreeIcon from '@components/icons/TreeIconLogin'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  root: {
    minWidth: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",

    "& .logo svg":{
      height: 50
    }
  },
  card: {
    maxWidth: "40%",
    minHeight: "20vh",
    display: "flex",
    flexDirection:"column",
    alignItems: "center"
  }

});

export default function LogInCt({children}) {
  const classes = useStyles();
  return (
    <Grid
      className={classes.root}
      spacing={0}
      alignItems="center"
      justify="center"
    >
      <Box className={classes.card}>

         <TreeIcon width={200}/>
          <Logo/>
          <div>
            {children}
          </div>
      </Box>
    </Grid>
  );
}
